import React, { useEffect, useState } from 'react';
import { useIsMobile } from '@/hooks/utilities/use-mobile';
import Seo from '@/components/shared/Seo';
import FullScreenGuard from '@/components/auth/FullScreenGuard';
import MobileMenu from '@/components/shared/MobileMenu';
import SearchHome from './SearchHome';
import { DSearchHome } from './desktop/DSearchHome';
import { useRouter } from 'next/router';
import MobileHomePage from '../home/mobile/Dashboard/MobileHomePage';
import PortfolioLayout from '../portfolio/desktop/PortfolioLayout';
import TradeMobileController from '../trade/mobile/TradeMobileController';
import FeedPage from '@/pages/feed';
import TradePage from '@/pages/trade';
import PortfolioPage from '@/pages/portfolio';
import classNames from '@/lib/misc/classNames';
import { useLocalStorage } from 'usehooks-ts';
import PageTransition from '../shared/PageTransition';
const HomeController = ({
  userName
}: {
  //referring user name SEO
  userName?: string;
}) => {
  const isMobile = useIsMobile();
  const seoString = userName ? `Join ${userName} on Genius • Trade Crypto Like a Genius • Find the Hottest New Tokens on Genius Terminal` : 'Explore • Find the Hottest New Tokens on Genius Terminal • Trade Crypto Like a Genius';
  const router = useRouter();
  const query = router.query;
  const mode: 'home' | 'portfolio' | 'trade' | 'feed' | 'search' = query.mode as any || 'home';
  if (isMobile) {
    return <>
        {(mode == 'home' || mode == 'search') && <div className='no-scrollbar'>
            {/* <PageTransition> */}
            
              <Seo title={seoString} />
              <SearchHome setSelectToAsset={() => {
          return;
        }} desktop={false} />
            {/* </PageTransition> */}
          </div>}
        {mode == 'feed' && <>
            <PageTransition>
              <FeedPage />
            </PageTransition>
          </>}
        {mode == 'portfolio' && <PageTransition>
            <PortfolioPage />
          </PageTransition>}
        {mode == 'trade' && <PageTransition>
            <TradePage />
          </PageTransition>}
        <MobileMenu />
      </>;
  } else {
    return <div className='h-full max-h-screen overflow-clip'>
        <Seo title={seoString} />
        <DSearchHome />
      </div>;
  }
};
export default HomeController;